
import { MainLayout } from '@/layout/MainLayout';
import { EngineMonitor } from '@/features/engine-monitoring/components/EngineMonitor';

const EngineMonitoring = () => {
  return (
    <MainLayout>
      <EngineMonitor />
    </MainLayout>
  );
};

export default EngineMonitoring;
